// src/routes/public/SetPassword.js
import React, { useState } from 'react';
import '../css/SetPassword.css';

const SetPassword = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');

  const isPasswordValid = (password) => {
    const minLength = 8;
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    const hasUpperCase = /[A-Z]/.test(password);
    return password.length >= minLength && hasSpecialChar && hasUpperCase;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError('Le password non coincidono');
      return;
    }

    if (!isPasswordValid(password)) {
      setError('La password non soddisfa i requisiti di sicurezza');
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_BASE_URL}/app/set-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        throw new Error('Errore, se il problema persiste contattare l\'amministratore');
      }

      if (response.status === 200) {
        const data = await response.json();
        const redirectUrl = data.redirectUrl;
        if (redirectUrl) {
          window.location.href = redirectUrl;
          return;
        }
      } else {
        setError("Impossibile impostare la password, se il problema persiste contattare l'amministratore");
      }
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <form className="set-password-form" onSubmit={handleSubmit}>
      <h2>Imposta Password</h2>
        <p className="password-requirements">
            La password dev'essere lunga almeno 8 caratteri, deve contenere un carattere speciale e almeno una lettera maiuscola.
        </p>
        <br />
      <div>
        <label>Email:</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>
      <div>
        <label>Password:</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </div>
      <div>
        <label>Conferma Password:</label>
        <input
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />
      </div>
      {error && <p className="error">{error}</p>}
      <button type="submit">Imposta Password</button>
    </form>
  );
};

export default SetPassword;